import { useEffect, useRef } from "react";

import { useWidget } from "/imports/state/WidgetContext";
import { useAuth } from "/imports/state/AuthContext";
import { setClub, identifyUser, resetUser } from "/imports/libs/analytics";

/**
 * Keeps PostHog's view of "which club, which person" in step with the app.
 *
 * Identity follows the user _id rather than each login method, so every way in
 * (password, Google, claim, verify link, session restored on load) is covered
 * once. Reset fires only on a real sign-out — the null user while the session
 * is still being restored on load must not wipe the visitor.
 */
function AnalyticsSync() {
  const { saasId, slug, saas } = useWidget();
  const { user, client, role } = useAuth();
  const userId = user?._id || null;
  const lastUserId = useRef(null);

  useEffect(() => {
    if (userId) {
      identifyUser({ userId, role, clientId: client?._id, saasId });
    } else if (lastUserId.current) {
      resetUser();
    }
    lastUserId.current = userId;
    // reset() drops super properties too, so the club goes back on afterwards.
    setClub({ saasId, slug, name: saas?.name });
  }, [userId, role, client?._id, saasId, slug, saas?.name]);

  return null;
}

export default AnalyticsSync;
